<template>
  <AnalyticsCard
    title="Your events"
    subtitle="Ranked by bookings, with how often each is canceled"
    :loading="loading"
    :empty="!loading && rows.length === 0"
    empty-title="No bookings in this period"
    empty-hint="Events start appearing here as soon as somebody books one."
    skeleton="list"
    :rows="5"
    :height="264"
  >
    <div class="flex items-center justify-between px-5 py-2 bg-gray-50 dark:bg-gray-800/40 border-b border-gray-100 dark:border-gray-700">
      <span class="text-[11px] font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">Event</span>
      <span class="text-[11px] font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">Bookings</span>
    </div>
    <RankedRows :rows="rows" />
  </AnalyticsCard>
</template>

<script setup>
import { computed } from 'vue'
import AnalyticsCard from '../shared/AnalyticsCard.vue'
import RankedRows from '../shared/RankedRows.vue'

const props = defineProps({
  data:    { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

const rows = computed(() => props.data.map(e => ({
  key: e.id,
  label: e.name,
  // The backend hands back a hex code, never the colour *name*. A dynamic
  // Tailwind class built from a backend string (`:class="event.color"`) is not
  // in the compiled stylesheet and silently renders nothing.
  swatch: e.color,
  value: e.bookings,
  weight: e.bookings,
  meta: e.share != null ? `${Math.round(e.share * 100)}% of bookings` : '',
  // Only worth a badge when it is actually happening. A "0% canceled" chip on
  // every healthy event is noise that hides the one that matters.
  badge: e.canceled > 0 ? `${Math.round(e.cancellation_rate * 100)}% canceled` : '',
  badgeClass: 'bg-red-50 dark:bg-red-900/20 text-red-500 dark:text-red-400',
})))
</script>
